import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MobileShell } from "@/components/MobileShell";

export default function DepartmentHome() {
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const dRes = await api.get("/departments");
                setDepartments(dRes.data);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <MobileShell>
            <div className="pt-8 md:pt-16 pb-20" data-testid="departments-page">
                {loading ? (
                    <div
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6"
                        data-testid="departments-loading"
                    >
                        {[...Array(6)].map((_, i) => (
                            <div
                                key={i}
                                className="h-40 md:h-52 rounded-3xl bg-surface/60 animate-pulse"
                            />
                        ))}
                    </div>
                ) : departments.length === 0 ? (
                    <div
                        data-testid="departments-empty"
                        className="min-h-[60vh] flex items-center justify-center"
                    >
                        <div className="w-full max-w-md h-52 rounded-3xl border border-dashed border-border/60" />
                    </div>
                ) : (
                    <section
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6"
                        data-testid="departments-grid"
                    >
                        {departments.map((d, i) => {
                            const slug = d.name.toLowerCase().replace(/\s+/g, "-");
                            return (
                                <Link
                                    key={d.id}
                                    to={`/shop/${encodeURIComponent(d.name)}`}
                                    data-testid={`department-card-${slug}`}
                                    className="group relative flex items-center justify-center h-40 md:h-52 rounded-3xl bg-gradient-to-br from-surface/70 via-background to-surface/40 border border-border/50 hover:border-primary/60 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-500 overflow-hidden animate-fadeUp"
                                    style={{ animationDelay: `${i * 70}ms` }}
                                >
                                    {/* Corner ornaments */}
                                    <span
                                        aria-hidden="true"
                                        className="absolute top-4 left-4 h-px w-6 bg-border/70 transition-all duration-500 group-hover:w-10 group-hover:bg-primary/70"
                                    />
                                    <span
                                        aria-hidden="true"
                                        className="absolute top-4 left-4 w-px h-6 bg-border/70 transition-all duration-500 group-hover:h-10 group-hover:bg-primary/70"
                                    />
                                    <span
                                        aria-hidden="true"
                                        className="absolute bottom-4 right-4 h-px w-6 bg-border/70 transition-all duration-500 group-hover:w-10 group-hover:bg-primary/70"
                                    />
                                    <span
                                        aria-hidden="true"
                                        className="absolute bottom-4 right-4 w-px h-6 bg-border/70 transition-all duration-500 group-hover:h-10 group-hover:bg-primary/70"
                                    />

                                    <div className="flex flex-col items-center px-6 text-center">
                                        <h2
                                            data-testid={`department-name-${slug}`}
                                            className="font-serif italic text-3xl md:text-4xl leading-none text-foreground tracking-tight transition-colors duration-500 group-hover:text-primary"
                                        >
                                            {d.name}
                                        </h2>
                                        <span
                                            aria-hidden="true"
                                            className="mt-4 block h-px w-8 bg-border transition-all duration-500 group-hover:w-20 group-hover:bg-primary"
                                        />
                                    </div>
                                </Link>
                            );
                        })}
                    </section>
                )}
            </div>
        </MobileShell>
    );
}
